import React, { useState } from 'react';
import PageDetails from '../PageDetails/PageDetails'
import TabFirst from '../TabFirst/TabFirst'


const tabsList = [
  {tabId: 'SOCIAL', displayText: 'Inspection'},
  {tabId: 'GAMES', displayText: 'Machine'},
  {tabId: 'NEWS', displayText: 'Workspace & Quality'},
  {tabId: 'FOOD', displayText: 'Inspection Tool'},
]

const appsList = [
  {
    appId: 0,
    appName: 'Facebook',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/social-facebook.png',
    category: 'SOCIAL',
    categoryDetails:[
      {
        InspectionItem: "Filter Condition",
        Description:"Check for any tears, holes, or damage to the paper filter material.",
        ActionRequired: "Replace if the filter material is damaged or excessively dirty.",
      },
      {
        InspectionItem: "Dirt Accumulation",
        Description:"Assess the amount of dirt and debris trapped in the filter.",
        ActionRequired: "Clean or replace the filter if heavily soiled to ensure optimal filtration.",
      },
      {
        InspectionItem: "Filter Housing",
        Description:"Inspect the housing for any cracks, leaks, or misalignmen.",
        ActionRequired: "Repair or replace the housing if damage is detected to maintain proper sealing.",
      },
      {
        InspectionItem: "Seal Integrity",
        Description:"Ensure that the seal between the filter and housing is intact and secure.",
        ActionRequired: "Replace the seal if any damage or leaking is observed to prevent oil leakage.",
      },
      {
        InspectionItem: "Oil Flow Restriction:",
        Description:"Measure the oil flow through the filter using appropriate tool.",
        ActionRequired: "Clean or replace the filter if there is a restriction in oil flow to prevent engine damage.",
      },
      {
        InspectionItem: "Installation",
        Description:"Verify the proper installation of the inline paper oil filter according to the manufacturer's instructions..",
        ActionRequired: "Reinstall the filter correctly if necessary to prevent leaks or improper sealing.",
      },
      {
        InspectionItem: "Filter Compatibility",
        Description:"Confirm that the filter is the correct type and size for the specific bike model.",
        ActionRequired: "Replace the filter with an appropriate one if compatibility issues are identified.",
      },
     

      {
        InspectionItem: "Maintenance History",
        Description:"Review previous maintenance records to determine when the filter was last inspected or Review previous maintenance records to determine when the inline paper oil filter was last inspected or replaced.",
        ActionRequired: " Schedule replacement or cleaning accordingly based on the manufacturer's recommended maintenance intervals.",
      }
    ]
  },
  
  {
    appId: 2,
    appName: 'Subway Surfers',
    imageUrl:
      'https://www.kanwalenterprises.com/public/images/products/img-automotive-filter-manufacturing-machines.jpg',
    category: 'GAMES',
    
  },

  
  {
    appId: 4,
    appName: 'Inshorts',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/news-inshorts.png',
    category: 'NEWS',
    heading:'Inline Paper Oil Filter',
    content:"The Inline Paper Oil Filter by Gifco delivers exceptional filtration capabilities for industrial applications. Manufactured in Bengaluru with precision and expertise, it adheres to stringent quality standards, ensuring reliable and efficient performance. Featuring an automatic function and sturdy design, it can handle heavy loads with ease, making it ideal for diverse industrial settings. Gifco's commitment to excellence guarantees long-lasting and hassle-free operation, providing peace of mind to users. As leading manufacturers, suppliers, and exporters of filtration solutions, we tailor our products to meet your specific needs effectively. Trust Gifco for superior quality and reliability in filtration technology.",
    features : [
      'Smooth performance',
      'Long running life',
      'Durable construction',
      'Smooth operation',
      'Automatic function',
    ],

    specifications : [
      'The specifications are  not fixed for the product and  we provide what our clients ask for.'
     
    ],

  },
  
  {
    appId: 5,
    appName: 'Zomato',
    imageUrl:
      'https://assets.ccbp.in/frontend/react-js/app-store/food-zomato.png',
    category: 'FOOD',
    imageUrl:""
  },
  
]

// Write your code here
const InlinepaperOilfiltersStore = () => {
  const [activeTabId, setActiveTabId] = useState(tabsList[0].tabId);
  const [searchInput, setSearchInput] = useState('');
  

  const getFilteredProjects = () => {
    const filterdata = appsList.filter(
      (eachdetails) => eachdetails.category === activeTabId
    );
    return filterdata;
  };

  const onchangestatus = (tabId) => {
    setActiveTabId(tabId);
  };

  const getinputdetails = (event) => {
    setSearchInput(event.target.value);
  };

  const fliterdataproject = getFilteredProjects();
  const searchresult = fliterdataproject.filter((eachfilterdata) =>
    eachfilterdata.appName.includes(searchInput)
  );

  return (
    <div className="appcontainer">
      <div className="cardcontainer">
        <div className="upcontainer">
          {/* <div className="search-input-container">
            <input
              type="search"
              className="search-input"
              placeholder="Search"
              onChange={getinputdetails}
            />
            <img
              src="https://assets.ccbp.in/frontend/react-js/app-store/app-store-search-img.png "
              alt="search icon"
              className="search_icon"
            />
          </div> */}
        </div>
        <ul className="tabitemcontainer">
          {tabsList.map((each) => (
            <TabFirst
              tabname={each}
              key={each.tabId}
              onchangestatus={onchangestatus}
              isActive={activeTabId === each.tabId}
            />
          ))}
        </ul>
        <ul className="appcontainer">
          {searchresult.map((each) => (
            <PageDetails Appitem={each} key={each.appId} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default InlinepaperOilfiltersStore;
